<template>
  <div class="user-record">
    <medicalRecord3 :patientCode="patientCode" />
    <followVisit :patientCode="patientCode" />
    <tabooInfo v-if="hasAuth('YZ-24')" :patientCode="patientCode" />
    <Card v-if="showFyxx" :bordered="true" dis-hover class="follow-visit">
      <div slot="title">服药信息记录</div>
      <diseaseCourseInformation
        ref="diseaseCourseInformationRef"
        v-if="patientCode"
        :patientCode="patientCode"
      />
    </Card>
  </div>
</template>

<script>
import { hasAuth } from "@/utils/uEdition.js";
import followVisit from "./followVisit.vue";
import medicalRecord3 from "./medicalRecord3.vue";
import tabooInfo from "./tabooInfo.vue";
export default {
  props: {
    patientCode: {
      type: String,
      default: "",
    },
    // 是否有百会
    hasBaiHui: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showFyxx() {
      return this.hasBaiHui; //&& hasAuth("YZ-25");
    },
  },
  components: {
    medicalRecord3,
    followVisit,
    tabooInfo,
  },
  methods: {
    hasAuth(code) {
      return hasAuth(code);
    },
    showEditWin() {
      this.$refs.diseaseCourseInformationRef.showEditWin();
    },
  },
};
</script>

<style lang="scss" scoped>
.user-record {
  padding: 15px;
  .ivu-card {
    margin-bottom: 15px;
  }
}
</style>